export default __webpack_public_path__ + "static/media/this_is_so_much_better.f1f861ca.svg";